import { render } from "./TitleMenu.vue?vue&type=template&id=397acf1e&scoped=true"
import script from "./TitleMenu.vue?vue&type=script&lang=js"
export * from "./TitleMenu.vue?vue&type=script&lang=js"

import "./TitleMenu.vue?vue&type=style&index=0&id=397acf1e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397acf1e"]])

export default __exports__